import { render, staticRenderFns } from "./digerBilgiler.vue?vue&type=template&id=6b07e104&"
import script from "./digerBilgiler.vue?vue&type=script&lang=js&"
export * from "./digerBilgiler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports